import React from "react";
import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { DashboardSectionProps } from "../type";
import { MetricCard } from "./MetricCard";
import { operationsDashboardStyles } from "../styles";
import { useApp } from "../../../contexts/AppContext";

export const DashboardSection: React.FC<DashboardSectionProps> = ({
  section,
  fullWidth = false,
}) => {
  const { drawerOpen } = useApp();
  
  const defaultColumns = {
    xs: 1,
    sm: 1,
    md: fullWidth ? 4 : 1,
    lg: fullWidth ? 6 : 3,
    xl: fullWidth ? 6 : 3,
  };

  const columns = section.columns ?? defaultColumns;

  const renderSectionHeader = () => {
    return (
      <Box sx={operationsDashboardStyles.sectionHeaderContainer}>
        <Typography sx={operationsDashboardStyles.sectionTitleBox}>
          {section.title}
        </Typography>
        <Box sx={operationsDashboardStyles.sectionBorderLine} />
      </Box>
    );
  };

  const renderMetricCards = () => {
    const getGridSize = () => {
      if (!fullWidth) {
        return {
          xs: 12 / (columns.sm ?? 1),
          sm: 12 / (columns.sm ?? 1),
          md: 12 / (columns.md ?? 2),
          lg: 12 / (columns.lg ?? 3),
          xl: 12 / (columns.xl ?? 3),
        };
      }
      return drawerOpen
        ? { xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }
        : { xs: 12, sm: 12, md: 3, lg: 3, xl: 3 };
    };

    const gridSize = getGridSize();

    return (
      <Grid container rowSpacing="1.5rem" columnSpacing="1.375rem">
        {section.metrics.map((metric) => {
          return (
            <Grid size={gridSize} key={metric.id}>
              <MetricCard data={metric} />
            </Grid>
          );
        })}
      </Grid>
    );
  };

  return (
    <Box sx={operationsDashboardStyles.sectionContainer}>
      {renderSectionHeader()}
      {renderMetricCards()}
    </Box>
  );
};
